import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Order/OrderPositioningSetup.requests'
import {
    PositioningSetupType,
} from '../orderConfirmation.types'

export default (orderNumber: string) => {
    return useRequest<PositioningSetupType>({
        key: RequestKeys.getPositioningSetup,
        params: {
            orderNumber,
        },
        requestFunc: RequestFn.getEntity(requests.getPositioningSetup),
        enabled: Boolean(orderNumber),
        keepPreviousData: true,
    })
}
